<template>
  <div class="page-card">
    <el-card>
      <div slot="header">客服电话配置</div>
      <el-form label-width="120px" style="max-width: 520px;">
        <el-form-item label="客服电话">
          <el-input v-model="phone" placeholder="例如 0731-88888888 或 11 位手机号" clearable />
        </el-form-item>
        <el-form-item label="合作咨询电话">
          <el-input v-model="cooperationPhone" placeholder="例如 0731-xxxxxxx 或 11 位手机号" clearable />
        </el-form-item>
        <el-form-item label="新用户初始积分">
          <el-input-number v-model="initialRegisterPoints" :min="0" :max="999999" />
        </el-form-item>
        <el-form-item label="打卡审核积分">
          <el-input-number v-model="auditPoints" :min="1" :max="9999" />
          <span class="sub-hint">用户上传的打卡点后台审核通过后，自动增加该积分（默认 10）</span>
        </el-form-item>
        <el-form-item label="核销默认距离">
          <el-input-number v-model="verifyRadiusM" :min="10" :max="500000" :step="100" />
          <span class="sub-hint">单位：米。默认 2000（即 2 公里）。活动配置了「核销范围」时仍以活动为准。</span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="saving" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import request from '@/api/request'

export default {
  name: 'CustomerServiceConfig',
  data() {
    return {
      phone: '',
      cooperationPhone: '',
      initialRegisterPoints: 0,
      auditPoints: 10,
      verifyRadiusM: 2000,
      saving: false
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      request.get('/configs').then(res => {
        const pack = res.data != null ? res.data : res
        const items = (pack && pack.items) || []
        const byKey = {}
        items.forEach(c => {
          if (c && c.key) byKey[c.key] = c
        })
        if (byKey.customer_service_phone) {
          this.phone = byKey.customer_service_phone.value || ''
        }
        if (byKey.cooperation_consult_phone) {
          this.cooperationPhone = byKey.cooperation_consult_phone.value || ''
        }
        if (byKey.user_register_initial_points) {
          const ip = parseInt(byKey.user_register_initial_points.value, 10)
          if (!isNaN(ip) && ip >= 0) this.initialRegisterPoints = ip
        }
        if (byKey.checkin_spot_audit_points) {
          const n = parseInt(byKey.checkin_spot_audit_points.value, 10)
          if (!isNaN(n) && n > 0) this.auditPoints = n
        }
        if (byKey.coupon_verify_default_radius_m) {
          const r = parseFloat(String(byKey.coupon_verify_default_radius_m.value || '').trim())
          if (!isNaN(r) && r >= 10) this.verifyRadiusM = Math.min(500000, r)
        }
      })
    },
    save() {
      const phone = (this.phone || '').trim()
      if (!phone) {
        this.$message.warning('请填写客服电话')
        return
      }
      const cooperationPhone = (this.cooperationPhone || '').trim()
      this.saving = true
      const p1 = request.post('/configs', {
        key: 'customer_service_phone',
        value: phone,
        description: '小程序客服中心展示号码'
      })
      const p1b = request.post('/configs', {
        key: 'cooperation_consult_phone',
        value: cooperationPhone,
        description: '小程序合作咨询展示号码（公司电话）'
      })
      const p2 = request.post('/configs', {
        key: 'user_register_initial_points',
        value: String(this.initialRegisterPoints != null ? this.initialRegisterPoints : 0),
        description: '新用户注册成功后的初始积分'
      })
      const p3 = request.post('/configs', {
        key: 'checkin_spot_audit_points',
        value: String(this.auditPoints || 10),
        description: '打卡点审核通过奖励积分'
      })
      const p4 = request.post('/configs', {
        key: 'coupon_verify_default_radius_m',
        value: String(this.verifyRadiusM != null ? this.verifyRadiusM : 2000),
        description: '优惠券现场核销默认距离（米），活动未配置 redeem_scope 时使用'
      })
      Promise.all([p1, p1b, p2, p3, p4])
        .then(() => {
          this.$message.success('保存成功')
        })
        .finally(() => {
          this.saving = false
        })
    }
  }
}
</script>

<style scoped>
.hint {
  color: #606266;
  font-size: 13px;
  margin: 0 0 16px;
}
.sub-hint {
  display: block;
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}
</style>
